import React from "react";
import { withRouter } from "react-router-dom";

import { PRIVACY } from "@/core/constants";

import { getQueryParams } from "../../utils/filters";
import { Policy } from "../../components/Policy/Policy";

const PrivacyPolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={PRIVACY} version={version} />;
};

export default withRouter(PrivacyPolicyPage);
